"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var query_string_1 = require("query-string");
exports.updateUrl = function (href, base) {
    if (base === void 0) { base = ''; }
    var url = new URL(href.toString(), window ? window.location.protocol + "//" + window.location.hostname : base);
    var hash = query_string_1.parse(url.hash);
    url.search = (url.search.length > 0 ? url.search + "&" : '?') + "sku=" + hash.sku + (hash['nav-c'] !== undefined ? "&nav-c=" + hash['nav-c'] : '');
    return url.toString();
};
var ProductLink = function (_a) {
    var _b = _a.href, href = _b === void 0 ? '' : _b, onClick = _a.onClick, children = _a.children, props = __rest(_a, ["href", "onClick", "children"]);
    return (react_1.default.createElement("a", __assign({}, props, { href: href, onClick: function (event) {
            event.preventDefault();
            if (onClick) {
                onClick(event);
            }
            if (typeof window !== 'undefined') {
                window.location.href = exports.updateUrl(href.toString());
            }
        } }), children));
};
exports.default = ProductLink;
//# sourceMappingURL=ProductLink.js.map